export default function degreeToRadian(angle: number): number {
  return angle * (Math.PI / 180);
}
